// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j3-0";
export var actionModalContentContainer = "_j3-1";
export var createTagButton = "_j3-2";
export var footerContainer = "_j3-7";
export var fullWidthDivider = "_j3-3";
export var hasCreateTagButton = "_j3-4";
export var noCreateTagButton = "_j3-5";
export var tagsContainer = "_j3-6";
export var tagsModalContentContainer = "_j3-8";